function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function SunIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 255.525c-141.424 0-256.475 115.075-256.475 256.498s115.053 256.498 256.475 256.498c141.401 0 256.475-115.053 256.475-256.498s-115.075-256.498-256.475-256.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 180.131c-27.641 0-50.044-22.403-50.044-50.021v-80.065c0-27.641 22.403-50.044 50.044-50.044s50.044 22.403 50.044 50.044v80.065c0 27.618-22.426 50.021-50.044 50.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 843.847c-27.641 0-50.044 22.403-50.044 50.044v80.043c0 27.663 22.403 50.066 50.044 50.066s50.044-22.403 50.044-50.066v-80.043c0-27.641-22.426-50.044-50.044-50.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M746.64 277.337c-19.523-19.546-19.523-51.223 0-70.768l56.619-56.619c19.523-19.523 51.223-19.523 70.768 0 19.546 19.546 19.546 51.245 0 70.768l-56.619 56.619c-19.523 19.546-51.2 19.546-70.768 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M277.337 746.686c-19.546-19.568-51.223-19.568-70.768 0l-56.619 56.597c-19.523 19.523-19.546 51.245 0 70.768s51.245 19.523 70.768 0l56.619-56.642c19.546-19.523 19.546-51.223 0-70.723z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M843.847 512c0-27.641 22.403-50.044 50.044-50.044h80.065c27.641 0 50.044 22.403 50.044 50.044s-22.403 50.021-50.044 50.021h-80.065c-27.641 0-50.044-22.38-50.044-50.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M180.131 512c0-27.641-22.403-50.044-50.044-50.044h-80.043c-27.641 0-50.044 22.403-50.044 50.044s22.403 50.021 50.044 50.021h80.065c27.618 0 50.021-22.38 50.021-50.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M746.64 746.686c19.546-19.523 51.245-19.523 70.768 0l56.619 56.619c19.546 19.5 19.546 51.223 0 70.746s-51.223 19.523-70.768 0l-56.619-56.619c-19.546-19.546-19.546-51.223 0-70.746z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M277.337 277.337c19.546-19.546 19.546-51.223 0-70.768l-56.619-56.597c-19.546-19.546-51.223-19.546-70.768 0-19.546 19.523-19.546 51.223 0 70.746l56.619 56.619c19.546 19.568 51.223 19.568 70.768 0z"
  })));
  return output;
}
